import axiosClient from './axiosClient';

const badgeApi = {
  create: (param) => {
    const url = `/badges`;
    return axiosClient.post(url, param);
  },
  update: (id, param) => {
    const url = `/badges/${id}`;
    return axiosClient.put(url, param);
  },
  get: (param) => {
    const url = '/badges?' + new URLSearchParams(param);
    return axiosClient.get(url);
  },
  getById: (id) => {
    const url = `/badges/${id}`;
    return axiosClient.get(url);
  },
  delete: (id) => {
    const url = `/badges/${id}`;
    return axiosClient.delete(url);
  },
  createBadgeType: (param) => {
    const url = `/badge-types`;
    return axiosClient.post(url, param);
  },
  getBadgeType: (params) => {
    const url = `/badge-types`;
    return axiosClient.get(url, { params });
  },
  updateBadgeType: (param, id) => {
    const url = `/badge-types/${id}`;
    return axiosClient.put(url, param);
  },
  deleteBadgeType: (id) => {
    const url = `/badge-types/${id}`;
    return axiosClient.delete(url);
  },
  getIntakeByCourseIDs: (id) => {
    const url = `/intakes/all?courses=${id}`;
    return axiosClient.get(url);
  },
  getlessonsByIntakeIds: (id, type) => {
    const url = `/units/get-units-by-intake?type=${type}&intakes=${id}`;
    return axiosClient.get(url);
  },
  getUserBadges: (id, params) => {
    const url = `/badges/user/${id}`;
    return axiosClient.get(url, { params });
  },
  getLessonsBadge: (body, params) => {
    const url = '/units/get-lessons?' + new URLSearchParams(params);
    return axiosClient.post(url, body);
  },
};
export default badgeApi;
